export const getOrientation = () => {

    return window.innerHeight >= window.innerWidth ? 'Portrait' : 'Landscape';

};

export const capitalize = (str) => {

    return str.charAt(0).toUpperCase() + str.substr(1);

};
